import React, { FC } from 'react';
import classnames from 'classnames/bind';
import { Radio } from '../FormInput/Variants/Radio/Radio';
import styles from './styles.module.css';

const cx = classnames.bind(styles);

type Option = {
  label: string;
  value: string;
};

export const RadioGroup: FC<{
  disabled?: boolean;
  name: string;
  value: string;
  options: Array<Option>;
  variant?: 'list' | 'inline';
  className?: string;
  onChange(value: string): void;
  labelId?: string;
}> = ({
  name,
  disabled,
  value,
  options,
  onChange,
  variant = 'list',
  className,
  labelId,
}) => {
  return (
    <div
      className={cx('wrapper', variant, { disabled }, className)}
      role="radiogroup"
      aria-labelledby={labelId}
      data-testid={`${name}-radiogroup`}
    >
      {options.map(option => (
        <Radio
          disabled={disabled}
          key={option.value}
          name={name}
          value={option.value}
          label={option.label}
          checked={value === option.value}
          onChecked={() => onChange(option.value)}
        />
      ))}
    </div>
  );
};
